import * as Styled from "./styled";

function MyLandsButton(props) {
  const handleCollapsedClick = () => {
    props.onExpand();
  };

  return (
    <Styled.Container>
      <Styled.Collapsed onClick={handleCollapsedClick} icon={require("./assets/ic-owned-lands.png")} />
    </Styled.Container>
  );
}

export default MyLandsButton;
